class NfeUploadModal {
    constructor(gql, scope) {
        this.gql = gql
        this.apply = (fn) => scope.$apply(fn)
        this.uploading = false
    }

    submit() {
        if (this.form && this.form.$valid) {
            if (this.resolve.zip)
                this.uploadZip()
            else
                this.uploadXml()
        }
    }

    upload(query, variables) {
	this.uploading = true

        const uploadProgress = (e) => {
            this.apply(() => this.progress = (e.loaded / e.total) * 100)
        }

        return this.gql
            .mutate(query, variables, { context: { uploadProgress } })
            .then(({ tarefaId }) => {
                Alert.success("Arquivo importado com sucesso!", "Sucesso")
                return tarefaId
            })
    }

    uploadZip() {
        const query = gql`
            mutation ImportNfeZip($empresaId: String! $file: Upload!, $emissaoPropria: Boolean!) {
                empresa(id: $empresaId) {
                    tarefaId: importNfeZip(file: $file, emissaoPropria: $emissaoPropria, empresaId: $empresaId)
                }
            }
        `
        const variables = { empresaId: this.resolve.contratoId.toString(), file: this.file, emissaoPropria: this.resolve.emissaoPropria }

        return this.upload(query, variables)
            .then(() => this.close())
            .catch(() => {
                this.apply(() => {
                    this.uploading = false
                    this.progress = 0
                    this.error = "Ocorreu um erro ao enviar o arquivo."
                })
            })
    }

    uploadXml() {
        const query = gql`
            mutation ImportNfeXml($empresaId: String!, $xml: Upload!, $emissaoPropria: Boolean!) {
                empresa(id: $empresaId) {
                    nfe: importNfeXml(xml: $xml, emissaoPropria: $emissaoPropria, empresaId: $empresaId) {
                        id
                    }
                }
            }
        `

        const variables = { empresaId: this.resolve.contratoId.toString(), xml: this.file, emissaoPropria: this.resolve.emissaoPropria }
        
        return this.upload(query, variables)
            .then(() => this.close())
            .catch(errors => {
                let [error] = errors
                this.apply(() => {
                    this.progress = 0
                    this.uploading = false
                    this.error = this.getErrorMessage(error.message)
                })
            })
    }

    getErrorMessage(error) {
        switch (error) {
            case "invalid_file":
                return "O arquivo enviado não é um XML."
            case "invalid_xml":
                return "O arquivo XML enviado não é um NF-e válido."
            case "invalid_nfe":
                return "O arquivo XML não atende ao formato exigido pela RFB."
            case "unsupported_version":
                return "Versão do XML não suportada."
            case "filial_divergente":
                return "A filial selecionada não é o destinatário da NF-e."
            case "nfe_emissao_propria":
                return "Essa NF-e foi emitida pela sua empresa, portanto deve ser importada no módulo \"NF-e/NFC-e emitidas\"."
            case "invalid_digest":
                return "O arquivo XML não atende ao formato exigido pela RFB ou não possui o elemento nfeProc."
            case "invalid_signature_value":
                return "A assinatura do XML é inválida."
            case "invalid_certificate":
                return "A assinatura do XML é inválida."
            case "invalid_signature":
                return "A assinatura do XML é inválida."
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeUploadModal', {
        controller: ['gql', '$scope', NfeUploadModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
            <modal title="Enviar {{ $ctrl.resolve.zip ? 'ZIP' : 'XML' }} NF-e" close="$ctrl.close">
                <modal-body>
                    <div class="form-group">
                        <label>Arquivo {{ $ctrl.resolve.zip ? 'ZIP' : 'XML' }}</label> <br/>
                        <input 
                            class="btn btn-default btn-block" 
                            ngf-select ngf-max-size="100MB" 
                            type="file" 
                            name="file" 
                            ng-model="$ctrl.file" 
                            accept="{{$ctrl.resolve.zip ? '.zip,.rar' : '.xml'}}"
                            required>
                        <div ng-messages="form.file.$error" ng-messages-multiple ng-messages-include="erros-validacao" ng-if="form.$submitted">
                            <span class='help-block txt-color-red font-xs no-margin' ng-message="maxSize">O arquivo deve ter no máximo 100MB.</span>
                        </div>
                    </div>
                    <highlighted ng-show="$ctrl.error">
                        <main>Ocorreu um erro na importação.</main>
                        <secondary class="text-danger">{{ $ctrl.error }}</secondary>
                    </highlighted>
                    <div class="progress" ng-class="{'progress-striped active': $ctrl.progress == 100}" ng-show="$ctrl.progress > 0">
                        <div class="progress-bar bg-color-blue" role='progressbar' ng-style="{ 'width': $ctrl.progress + '%' }"></div>
                    </div>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-primary" ng-disabled="$ctrl.uploading" type="submit">Enviar</button>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        </form>
        `
    })
